import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthAppService } from '../auth-app/auth-app.service';

@Injectable()
export class JWTAuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthAppService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.auth.getToken() || this.auth.getBackendToken()) {
      if (this.auth.clientType() === 'backend') {
        req = req.clone({
          setHeaders: {
            Authorization: `JWT ${this.auth.getBackendToken()}`,
            'Content-Type': 'application/json',
            Client: 'backend'
          }
        });
      } else {
        req = req.clone({
          setHeaders: {
            Authorization: `JWT ${this.auth.getToken()}`,
            'Content-Type': 'application/json',
            Client: 'frontend'
          }
        });
      }
    } else {
      req = req.clone({
        setHeaders: { 'Content-Type': 'application/json' }
      });
    }

    return next.handle(req);
  }
}
